<template>
  <div class="mt-3">
    <div v-if="isAuthenticated">
      <b-container fluid="md">
        <b-row>
          <b-navbar class="flex flex-row-reverse">
            <b-navbar-nav class="ms-auto">
              <b-nav-item-dropdown placement="bottom-end" data-testid="user-menu">
                <template #button-content>
                  <em>Welcome, {{ name }}</em>
                </template>
                <b-dropdown-item @click="showPasswordModal = true">Password reset</b-dropdown-item>
                <b-dropdown-item @click="logout">Logout</b-dropdown-item>
              </b-nav-item-dropdown>
            </b-navbar-nav>
          </b-navbar>
        </b-row>
      </b-container>

      <HomeComponent />
      <b-modal v-model="showPasswordModal" title="Reset your password" ok-only>
        <p class="my-4">
          To reset your password, please logout, click "Register or Login", then select the "Forgot
          your password?" link on the sign-in page.
        </p>
      </b-modal>
    </div>
    <div v-else>
      <b-container fluid="md" class="flex flex-column justify-content-around h-100">
        <Title />
        <WelcomeComponent />
        <FooterComponent />
      </b-container>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, getCurrentInstance } from 'vue';
import Title from '@/components/Title.vue';
import FooterComponent from '@/components/Footer.vue';
import WelcomeComponent from '@/components/Welcome.vue';
import HomeComponent from '@/components/Home.vue';
import { useDosingStore } from '@/stores/dosing';

defineOptions({ name: 'LandingComponent' });

const store = useDosingStore();
const { proxy } = getCurrentInstance()!;
const showPasswordModal = ref(false);

const isAuthenticated = computed(() => !!store.getMember);
const member = computed(() => store.getMember ?? (proxy as any).$msal.getUser());
const name = computed(() => {
  const m = member.value;
  return m?.name !== 'unknown' ? m?.name : (m?.idTokenClaims?.given_name ?? 'Member');
});

function logout() {
  store.logout();
  return (proxy as any).$msal.logout();
}
</script>

<style scoped></style>
